module.exports = __webpack_public_path__ + "static/media/easypaisa.ca2f1a87.png";